import { makeStyles } from "@material-ui/core";
import * as yup from "yup";

export const stylesUse = makeStyles(theme => ({
    imageStyle: {
        width: 160,
        height: 160,
        objectFit: "contain",
    },
    imageStyleLg: {
        width: 300,
        height: 160,
        objectFit: "contain",
    },
}));

export const newsEventsSchema = yup.object({
    titleTh: yup.string().required("Title Thai is required."),
    titleEn: yup.string().required("Title Eng is required."),
    startDate: yup.date().nullable().typeError("Invalid Date").required("Date Start is required."),
    endDate: yup.date().nullable().typeError("Invalid Date").required("Date End is required."),
    fileThumbs: yup.array().required("Thumbnail is required."),
    fileImages: yup.array().required("Image is required."),
    contentTh: yup.string().required("Content Thai is required."),
    contentEn: yup.string().required("Content Eng is required."),
});

export const initialValues = {
    titleTh: "",
    titleEn: "",
    startDate: new Date(),
    endDate: new Date(),
    fileImages: [],
    fileThumbs: [],
    contentTh: "",
    contentEn: "",
};
